// extracted by mini-css-extract-plugin
export default {"homeContainer":"home_homeContainer__tP8UY","homeContent":"home_homeContent__+B6nK"};